import React from "react";

import { Trans } from "@lingui/macro";

export const TitleInvitesList = <Trans id="invitesList.block.title">Sharing</Trans>;
